var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-content"},[(_vm.post.isText)?_c('Post_Section_Text',{attrs:{"post":_vm.post}}):_c('Post_Section_Image',{attrs:{"image-url":_vm.post.imageUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }